/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Finals_Not_Enough_PlayersInputs */



/**
* | output |
* | --- |
* | "Need at least 5 eligible players with results for finals" |
*
* @param {Err_Tournament_Finals_Not_Enough_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_finals_not_enough_players = /** @type {((inputs?: Err_Tournament_Finals_Not_Enough_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Finals_Not_Enough_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au moins 5 joueurs éligibles avec des résultats sont nécessaires pour la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se necesitan al menos 5 jugadores elegibles con resultados para las finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("São necessários pelo menos 5 jogadores elegíveis com resultados para as finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sono necessari almeno 5 giocatori idonei con risultati per le finali")
	return /** @type {LocalizedString} */ ("Need at least 5 eligible players with results for finals")
});